import { Box, Fade } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import ToolEntryButton from '~/components/toolbar/shared/ToolEntryButton';
import ToolHoverTray from '~/components/toolbar/shared/ToolHoverTray';
import { useViewingToolEntries } from '~/components/toolbar/shared/useViewingToolEntries';
import PanToolOptions from './PanToolOptions';

export default function PanTool() {
    const { pan } = useViewingToolEntries();
    const [hovered, setHovered] = useState(false);
    const enterTimeout = useRef<ReturnType<typeof setTimeout>>();
    const leaveTimeout = useRef<ReturnType<typeof setTimeout>>();

    const handleMouseEnter = () => {
        clearTimeout(leaveTimeout.current);
        enterTimeout.current = setTimeout(() => setHovered(true), 500);
    };

    const handleMouseLeave = () => {
        clearTimeout(enterTimeout.current);
        leaveTimeout.current = setTimeout(() => setHovered(false), 150);
    };

    useEffect(() => {
        return () => {
            clearTimeout(enterTimeout.current);
            clearTimeout(leaveTimeout.current);
        };
    }, []);

    return (
        <Box
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{ position: 'relative' }}
        >
            <ToolEntryButton entry={pan} tooltipPlacement="left" />
            <Fade
                in={hovered}
                timeout={{ enter: 200, exit: 150 }}
                unmountOnExit
            >
                <ToolHoverTray>
                    <PanToolOptions />
                </ToolHoverTray>
            </Fade>
        </Box>
    );
}
